// extracted by mini-css-extract-plugin
export default {"floating":"Yg57C9L_b2OHrt_bjWzK","pulse":"m2TwyUsoQDtDqvAa1Pat"};